<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Audit Section Configuration</h2>
  </div>
  
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="container">
      <div class="left-container">
        <section class="section-container nrg-border-radius">
          <div class="section-header">
            Choose a Country
          </div>
          <div class="section-content">
            <div class="section-field">
              <div class="select-with-button">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="country" name="countryId" placeholder="Country">
                    <mat-option *ngFor="let country of countries" [value]="country.id">
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="right-container">
        <section class="section-container nrg-border-radius">
          <div class="section-header">
            Audit Fee Categories Not Visible
          </div>
          <div class="section-content">
            <div class="section-field">
              @for (group of groupedCategories; track group.label) {
                <mat-card class="category-card">
                  <mat-card-header>
                    <strong>{{ group.label }}</strong>
                  </mat-card-header>
                  <mat-card-content>
                    @for (category of group.categories; track category.id) {
                      <div class="category-item">
                        <mat-checkbox
                          [checked]="isCategorySelected(category.id)"
                          (change)="toggleCategory(category.id)">
                          {{ category.name }}
                        </mat-checkbox>
                      </div>
                    }
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="form-actions">
      <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="!form.valid || !hasChanges()">
        <mat-icon>save</mat-icon>
        Submit
      </button>
    </div>
  </form>

</div>
